import { MonthlyPrayerTimes } from '../types';

export const aprilPrayerTimes: MonthlyPrayerTimes = {
  1: {
    fajr: "03:40",
    shoruk: "06:07",
    dhuhr: "12:57",
    asr: "16:23",
    maghrib: "19:36",
    isha: "21:42"
  },
  2: {
    fajr: "03:38",
    shoruk: "06:04",
    dhuhr: "12:56",
    asr: "16:25",
    maghrib: "19:39",
    isha: "21:43"
  },
  3: {
    fajr: "03:37",
    shoruk: "06:01",
    dhuhr: "12:56",
    asr: "16:26",
    maghrib: "19:41",
    isha: "21:44"
  },
  4: {
    fajr: "03:36",
    shoruk: "05:58",
    dhuhr: "12:56",
    asr: "16:27",
    maghrib: "19:43",
    isha: "21:45"
  },
  5: {
    fajr: "03:35",
    shoruk: "05:55",
    dhuhr: "12:56",
    asr: "16:29",
    maghrib: "19:46",
    isha: "21:46"
  },
  6: {
    fajr: "03:34",
    shoruk: "05:53",
    dhuhr: "12:55",
    asr: "16:30",
    maghrib: "19:48",
    isha: "21:47"
  },
  7: {
    fajr: "03:33",
    shoruk: "05:50",
    dhuhr: "12:55",
    asr: "16:31",
    maghrib: "19:51",
    isha: "21:47"
  },
  8: {
    fajr: "03:32",
    shoruk: "05:47",
    dhuhr: "12:55",
    asr: "16:32",
    maghrib: "19:53",
    isha: "21:48"
  },
  9: {
    fajr: "03:31",
    shoruk: "05:44",
    dhuhr: "12:55",
    asr: "16:34",
    maghrib: "19:55",
    isha: "21:49"
  },
  10: {
    fajr: "03:30",
    shoruk: "05:41",
    dhuhr: "12:54",
    asr: "16:35",
    maghrib: "19:58",
    isha: "21:50"
  },
  11: {
    fajr: "03:30",
    shoruk: "05:38",
    dhuhr: "12:54",
    asr: "16:36",
    maghrib: "20:00",
    isha: "21:51"
  },
  12: {
    fajr: "03:29",
    shoruk: "05:35",
    dhuhr: "12:54",
    asr: "16:37",
    maghrib: "20:02",
    isha: "21:52"
  },
  13: {
    fajr: "03:28",
    shoruk: "05:32",
    dhuhr: "12:53",
    asr: "16:39",
    maghrib: "20:05",
    isha: "21:53"
  },
  14: {
    fajr: "03:27",
    shoruk: "05:29",
    dhuhr: "12:53",
    asr: "16:40",
    maghrib: "20:07",
    isha: "21:54"
  },
  15: {
    fajr: "03:26",
    shoruk: "05:26",
    dhuhr: "12:53",
    asr: "16:41",
    maghrib: "20:10",
    isha: "21:55"
  },
  16: {
    fajr: "03:25",
    shoruk: "05:24",
    dhuhr: "12:53",
    asr: "16:42",
    maghrib: "20:12",
    isha: "21:56"
  },
  17: {
    fajr: "03:24",
    shoruk: "05:21",
    dhuhr: "12:52",
    asr: "16:43",
    maghrib: "20:14",
    isha: "21:57"
  },
  18: {
    fajr: "03:23",
    shoruk: "05:18",
    dhuhr: "12:52",
    asr: "16:44",
    maghrib: "20:17",
    isha: "21:57"
  },
  19: {
    fajr: "03:22",
    shoruk: "05:15",
    dhuhr: "12:52",
    asr: "16:46",
    maghrib: "20:19",
    isha: "21:58"
  },
  20: {
    fajr: "03:21",
    shoruk: "05:12",
    dhuhr: "12:52",
    asr: "16:47",
    maghrib: "20:21",
    isha: "21:59"
  },
  21: {
    fajr: "03:20",
    shoruk: "05:09",
    dhuhr: "12:52",
    asr: "16:48",
    maghrib: "20:24",
    isha: "22:00"
  },
  22: {
    fajr: "03:20",
    shoruk: "05:07",
    dhuhr: "12:51",
    asr: "16:49",
    maghrib: "20:26",
    isha: "22:01"
  },
  23: {
    fajr: "03:19",
    shoruk: "05:04",
    dhuhr: "12:51",
    asr: "16:50",
    maghrib: "20:29",
    isha: "22:02"
  },
  24: {
    fajr: "03:18",
    shoruk: "05:01",
    dhuhr: "12:51",
    asr: "16:51",
    maghrib: "20:31",
    isha: "22:03"
  },
  25: {
    fajr: "03:16",
    shoruk: "04:58",
    dhuhr: "12:51",
    asr: "16:52",
    maghrib: "20:33",
    isha: "22:04"
  },
  26: {
    fajr: "03:14",
    shoruk: "04:56",
    dhuhr: "12:51",
    asr: "16:53",
    maghrib: "20:36",
    isha: "22:06"
  },
  27: {
    fajr: "03:13",
    shoruk: "04:53",
    dhuhr: "12:51",
    asr: "16:54",
    maghrib: "20:38",
    isha: "22:07"
  },
  28: {
    fajr: "03:11",
    shoruk: "04:50",
    dhuhr: "12:50",
    asr: "16:56",
    maghrib: "20:41",
    isha: "22:09"
  },
  29: {
    fajr: "03:09",
    shoruk: "04:47",
    dhuhr: "12:50",
    asr: "16:57",
    maghrib: "20:43",
    isha: "22:10"
  },
  30: {
    fajr: "03:08",
    shoruk: "04:45",
    dhuhr: "12:50",
    asr: "16:58",
    maghrib: "20:45",
    isha: "22:12"
  }
};